import { createApp } from 'vue/dist/vue.esm-bundler.js'
import TInput from '@/components/ui/TInput.vue'
import TRadioGroup from '@/components/ui/TRadioGroup.vue'
import TButton from '@/components/ui/TButton.vue'
import TCheckbox from '@/components/ui/TCheckbox.vue'
import Alert from '@/components/ui/Alert.vue'
import Icon from '@/components/ui/Icon.vue'
import Image from '@/components/Image.vue'
import HijackBar from '@/components/HijackBar.vue'
import '../index.css'

import * as outlineIcons from '@heroicons/vue/outline'
import * as solidIcons from '@heroicons/vue/solid'
import LoadingIcon from '@/components/icons/LoadingIcon.vue'
import MaskIcon from '@/components/icons/MaskIcon.vue'

const app = createApp({})
  .component('TInput', TInput)
  .component('Alert', Alert)
  .component('TRadioGroup', TRadioGroup)
  .component('TButton', TButton)
  .component('TCheckbox', TCheckbox)
  .component('Icon', Icon)
  .component('LoadingIcon', LoadingIcon)
  .component('MaskIcon', MaskIcon)
  .component('HijackBar', HijackBar)
  .component('Image', Image)

Object.entries(outlineIcons).forEach((entry) => {
  app.component(entry[0], outlineIcons[entry[0]])
})
Object.entries(solidIcons).forEach((entry) => {
  app.component(`Solid${entry[0]}`, solidIcons[entry[0]])
})

app.mount('#app')
